import { render, staticRenderFns } from "./Ninety-five_percent.vue?vue&type=template&id=60389f29&scoped=true"
import script from "./Ninety-five_percent.vue?vue&type=script&lang=js"
export * from "./Ninety-five_percent.vue?vue&type=script&lang=js"
import style0 from "./Ninety-five_percent.vue?vue&type=style&index=0&id=60389f29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60389f29",
  null
  
)

export default component.exports